<template lang="pug">
    .layout-header
        .layout-header-content
            .btn
                .content
                    a(@click="$router.back()" v-if="$route.name != 'Ceping'")
                        i.icon.icon-back
                    router-link(:to="{name: 'Ceping'}")
                        i.icon.icon-shouye2
                    slot(name="left")
            .middle(v-if="title || $route.meta.title") 
                span {{title || $route.meta.title}}
            .middle(v-else)
                slot
            .btn
                .content.r
                    router-link(:to="{name: 'Search'}")
                        i.icon.icon-bars
                    slot(name="right")
    </template>
<script>
export default {
    name: "YcHeader",

    props: {
        title: {
            type: String,
            default: ''
        }
    },

    methods: {

    },

    data () {
        return {
            publicPath: process.env.BASE_URL
        }
    }
}
</script>
<style lang="less" scoped>
.layout-header              {height: 1.24rem;position: fixed;top: 0;left: 0;width: 100%;z-index: 100;background: #FFF;border-bottom: 1px solid #eaeaea;
    &-content               {max-width: 10rem;width: 100%;margin: 0 auto;display: flex;
        .btn                {width: 2rem;height: 1.24rem;
            .content        {display: flex;align-items: center;height: 1.24rem;
                &.r         {justify-content: flex-end;}
                a           {display: flex;height: .8rem;width: 1rem;justify-content: center;align-items: center;
                    i       {.fs(26);color: #666;}
                }
            }
        }
        .middle             {width: 6rem;display: flex;justify-content: center;align-items: center;height: 1.24rem;color: #333;
            span            {overflow: hidden;text-overflow:ellipsis;white-space: nowrap;margin: 0 .4rem;.fs(16);}
        }
    }
}
</style>